import { render } from "./modalJoinMapInPlay.vue?vue&type=template&id=2826e642"
import script from "./modalJoinMapInPlay.vue?vue&type=script&lang=js"
export * from "./modalJoinMapInPlay.vue?vue&type=script&lang=js"

import "./modalJoinMapInPlay.vue?vue&type=style&index=0&id=2826e642&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__